module.exports = __webpack_public_path__ + "static/media/get-yardnapha.ee72099f.mp3";